import * as tslib_1 from "tslib";
import { Sample } from "./Sample";
/**
 * The NewObjectSample class represents objects that are created within a <codeph class="+ topic/ph pr-d/codeph ">getSamples()</codeph> stream.
 * For Flash Player debugger version only.
 */
var NewObjectSample = (function (_super) {
    tslib_1.__extends(NewObjectSample, _super);
    function NewObjectSample() {
        return _super.call(this) || this;
    }
    Object.defineProperty(NewObjectSample.prototype, "object", {
        /**
         * The NewObjectSample object if it still exists. If the object has been garbage collected, this property is
         * undefined and a corresponding DeleteObjectSample exists. For Flash Player debugger version only.
         */
        get: function () {
            console.log("object not implemented yet in flash/NewObjectSample");
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NewObjectSample.prototype, "size", {
        /**
         * The NewObjectSample object size. If the object has been garbagecollected, this property is
         * undefined and a corresponding DeleteObjectSample exists. For FlashPlayer debugger version only.
         */
        get: function () {
            console.log("size not implemented yet in flash/NewObjectSample");
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    return NewObjectSample;
}(Sample));
export { NewObjectSample };
